import { render, staticRenderFns } from "./DoctorInfoTempModal.vue?vue&type=template&id=7c85a111&"
import script from "./DoctorInfoTempModal.vue?vue&type=script&lang=js&"
export * from "./DoctorInfoTempModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports